import { Star } from "lucide-react";

const WORDS = [
  "INTERNET-FIRST",
  "CULTURE-LED",
  "GLOBAL ROSTER",
  "MUSIC NATIVE",
  "ALWAYS ON",
  "DEAL CLOSERS",
  "BUILT FOR VIRALITY",
];

export const MarqueeStrip = () => {
  // Duplicate to create seamless loop
  const items = [...WORDS, ...WORDS, ...WORDS, ...WORDS];

  return (
    <section
      data-testid="marquee-strip"
      aria-hidden="true"
      className="relative bg-[#050505] border-y border-white/10 py-8 md:py-10 overflow-hidden"
    >
      <div className="flex whitespace-nowrap marquee-slow will-change-transform">
        {items.map((w, i) => (
          <div
            key={`${w}-${i}`}
            className="flex items-center gap-8 md:gap-12 pr-8 md:pr-12"
          >
            <span className="font-display text-3xl md:text-5xl lg:text-6xl font-light tracking-tighter text-white/80 hover:text-white transition-colors">
              {w}
            </span>
            <Star
              className="h-4 w-4 md:h-5 md:w-5 text-white/30 shrink-0"
              strokeWidth={1.2}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default MarqueeStrip;
